import { render, staticRenderFns } from "./screening-check-result-dialog.vue?vue&type=template&id=198ad89f&scoped=true"
import script from "./screening-check-result-dialog.vue?vue&type=script&lang=js"
export * from "./screening-check-result-dialog.vue?vue&type=script&lang=js"
import style0 from "./screening-check-result-dialog.vue?vue&type=style&index=0&id=198ad89f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ad89f",
  null
  
)

export default component.exports